import { classNames } from '@vkontakte/vkui';
import styles from './HeaderLayout.module.css';

interface HeaderLayoutProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Компонент для отрисовки фона шапки Крашей
 */
export function HeaderLayout(props: HeaderLayoutProps) {
  const { children, className } = props;

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.wrapper}>{children}</div>
    </div>
  );
}
